import { useMemo } from 'react';
import { Link } from 'foundations-components/transitional/components/Link';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import SourceDescriptionIcon from './SourceDescriptionIcon';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SourceLabelSection = ({
  label,
  description,
  instance,
  width
}) => {
  const instanceSectionContent = useMemo(() => {
    if (instance && instance.name && instance.relativeUri) return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(View, {
        maxInlineSize: `${width}`,
        children: /*#__PURE__*/_jsx(Link, {
          truncate: true,
          "data-test-id": "source-interpretation-instance-link",
          href: `${window.location.origin}/${instance.relativeUri}`,
          external: true,
          children: instance.name
        })
      })
    });

    // Instance with name only
    if (instance && instance.name) return /*#__PURE__*/_jsx(Small, {
      "data-test-id": "source-interpretation-instance-name",
      children: /*#__PURE__*/_jsx(TruncateString, {
        maxWidth: width,
        children: instance.name
      })
    });
    return undefined;
  }, [instance, width]);
  const labelSectionContent = useMemo(() => {
    const hasDescription = description !== '';
    return /*#__PURE__*/_jsx(Flex, {
      "data-test-id": "source-interpretation-label",
      alignItems: "center",
      children: /*#__PURE__*/_jsx(View, {
        marginBlockEnd: "0",
        paddingBlockEnd: "0",
        inlineSize: "block",
        paddingInlineEnd: "50",
        children: /*#__PURE__*/_jsx(TruncateString, {
          tooltip: label,
          maxWidth: width,
          useFlex: hasDescription,
          alignItems: "center",
          fixedChildren: hasDescription && /*#__PURE__*/_jsx(SourceDescriptionIcon, {
            description: description
          }),
          children: label
        })
      })
    });
  }, [label, width, description]);
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "source-interpretation-section",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "0",
      paddingBlockEnd: "0",
      inlineSize: "block",
      paddingInlineEnd: "50",
      children: /*#__PURE__*/_jsxs(TruncateString, {
        maxWidth: width,
        useFlex: true,
        tooltip: false,
        children: [labelSectionContent, instanceSectionContent]
      })
    })
  });
};
export default SourceLabelSection;